import type { HudStore } from './store';

export function Captions({ store }: { store: HudStore }) {
  const caps = store.captions.value;
  return (
    <div class="captions" role="log" aria-live="polite" aria-label="Race commentary">
      {caps.map((c) => <p key={c.id} class={`caption ${c.kind}`}>{c.text}</p>)}
    </div>
  );
}
